const cards = [
  {
    title: '顶流男星私会门',
    desc: '深夜酒店密会全程追踪',
    tag: '独家',
    img: 'https://readdy.ai/api/search-image?query=paparazzi%20style%20photo%20of%20luxury%20hotel%20entrance%20at%20night%20with%20dramatic%20lighting%2C%20mysterious%20atmosphere%2C%20red%20carpet%20ambience%2C%20editorial%20news%20photography%20style%2C%20dark%20moody%20tones%20with%20warm%20highlights&width=800&height=600&seq=card-51hlw-01&orientation=landscape',
  },
  {
    title: '网红直播间翻车',
    desc: '不当言论引发全网抵制',
    tag: '热议',
    img: 'https://readdy.ai/api/search-image?query=dramatic%20live%20streaming%20studio%20setup%20with%20warm%20ring%20light%20glow%2C%20professional%20streaming%20equipment%2C%20dark%20moody%20background%2C%20cinematic%20lighting%2C%20social%20media%20aesthetic&width=800&height=600&seq=card-51hlw-02&orientation=landscape',
  },
  {
    title: '女团聊天记录泄露',
    desc: '三年私密对话完整曝光',
    tag: '实锤',
    img: 'https://readdy.ai/api/search-image?query=smartphone%20screen%20showing%20chat%20messages%20with%20dramatic%20lighting%2C%20dark%20atmosphere%2C%20mysterious%20vibe%2C%20night%20scene%2C%20warm%20screen%20glow%20against%20dark%20background%2C%20editorial%20style&width=800&height=600&seq=card-51hlw-03&orientation=landscape',
  },
  {
    title: '综艺录制现场争执',
    desc: '嘉宾发飙离场内幕还原',
    tag: '内幕',
    img: 'https://readdy.ai/api/search-image?query=television%20studio%20set%20with%20dramatic%20spotlights%20and%20empty%20chairs%2C%20behind%20the%20scenes%20atmosphere%2C%20professional%20production%20environment%2C%20dark%20background%20with%20warm%20stage%20lighting&width=800&height=600&seq=card-51hlw-04&orientation=landscape',
  },
  {
    title: '说唱歌手税务风波',
    desc: '工作室紧急回应调查',
    tag: '跟进',
    img: 'https://readdy.ai/api/search-image?query=modern%20office%20building%20at%20dusk%20with%20dramatic%20sky%2C%20corporate%20headquarters%20silhouette%2C%20warm%20interior%20lights%20glowing%2C%20serious%20business%20atmosphere%2C%20editorial%20photography&width=800&height=600&seq=card-51hlw-05&orientation=landscape',
  },
  {
    title: '剧组未播片段泄密',
    desc: '制作方启动法律追责',
    tag: '独家',
    img: 'https://readdy.ai/api/search-image?query=film%20production%20set%20with%20professional%20camera%20equipment%2C%20dramatic%20lighting%20rig%2C%20behind%20the%20scenes%20movie%20studio%2C%20dark%20atmosphere%20with%20warm%20spotlights%2C%20cinematic%20mood&width=800&height=600&seq=card-51hlw-06&orientation=landscape',
  },
  {
    title: '新片选角潜规则疑云',
    desc: '多位新人试镜视频外流',
    tag: '深扒',
    img: 'https://readdy.ai/api/search-image?query=audition%20room%20with%20dramatic%20spotlight%20on%20empty%20stage%2C%20casting%20call%20atmosphere%2C%20theater%20auditorium%20vibe%2C%20dark%20background%20with%20single%20warm%20light%2C%20editorial%20drama%20style&width=800&height=600&seq=card-51hlw-07&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-3">精选专题</span>
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">热门专题</h2>
          <p className="text-foreground-600 text-sm mt-2">吃瓜群众都在追的独家深扒</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cards.map((card, i) => (
            <div key={i} className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden cursor-pointer transition-all hover:border-primary-200">
              <div className="relative aspect-[4/3] overflow-hidden bg-background-200">
                <img
                  src={card.img}
                  alt={`51黑料网 - ${card.title}`}
                  title={`51黑料网爆料 - ${card.title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    (e.target as HTMLElement).parentElement!.style.display = 'none';
                  }}
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-semibold">
                    {card.tag}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-base font-bold text-foreground-900 mb-1.5 group-hover:text-primary-600 transition-colors">{card.title}</h3>
                <p className="text-sm text-foreground-600">{card.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}